import { GraphSchema } from '@camelot/server';

export interface ColorSet {
  id: string;
  textColor: string;
  backgroundColor: string;
  borderColor: string;
}

export interface ColorSetCreationPayloadInput {
  textColor: string;
  backgroundColor: string;
  borderColor: string;
}

export interface ColorSetModifierPayloadInput {
  id: string;
  textColor: string;
  backgroundColor: string;
  borderColor: string;

  updatedFields: string[];
}

export const colorSetProps = new GraphSchema<ColorSet>(['id', 'textColor', 'backgroundColor', 'borderColor']);
